import { Fade, Card, Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { useMemo } from "react";
import { getUproColor } from "utils/colors";
import successIcon from "assets/images/checked_324776.png";
import { appPath } from "services/config";

function SuccessComedor() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const pedidoId = params.get("pedido");

  return (
    <SoftBox
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: getUproColor("uproPink"),
      }}
    >
      <Fade in={true} unmountOnExit>
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: "100%",
              borderRadius: "3rem",
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              boxShadow: "0 ",
              padding: "3rem",
              margin: "2rem",
            }}
          >
            <SoftBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              width="100%"
            >
              <SoftBox component="img" src={successIcon} alt="Exito" width="10rem" p={3} />
              <SoftTypography variant="h4" fontWeight="bold" color="white" gutterBottom mt={1}>
                Transacción exitosa!
              </SoftTypography>
              <SoftTypography variant="h6" color="text" mt={2}>
                Tu pedido{pedidoId ? ` #${pedidoId}` : ""} será reservado.
              </SoftTypography>
              <SoftBox mt={4}>
                <SoftButton
                  color="uproGreen"
                  circular
                  fullWidth
                  onClick={() => (window.location.href = appPath("/sistema-comedor"))}
                >
                  Volver al inicio
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </Card>
        </Grid>
      </Fade>
    </SoftBox>
  );
}

export default SuccessComedor;
